import { Component, OnInit, EventEmitter, Input, Output, forwardRef } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { Observable } from 'rxjs/Observable';

import { Onix } from '../../../models/Onix';
import { Argomento } from '../../../models/Argomento';
import { BookService } from './../../../services/book.service';

@Component({
  selector: 'app-argomento-selector',
  templateUrl: './argomento-selector.component.html',
  styleUrls: ['./argomento-selector.component.css'],
  providers: [
    BookService,
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => ArgomentoSelectorComponent),
      multi: true
    }
  ]
})
export class ArgomentoSelectorComponent implements OnInit {

  selectedArgomento: Argomento;

  @Input() eraseable: boolean;
  @Output() removeNotify: EventEmitter<any> = new EventEmitter<any>();

  constructor(private bookService: BookService) { }

  ngOnInit() { }

  onArgomentoChange(e) {
    this.propagateChange(this.toModel());
  }

  toModel() {
    return this.selectedArgomento ? {
      codice: this.selectedArgomento.codice,
      descrizione: this.selectedArgomento.descrizione,
    } : {}
  }

  eraseMe() {
    this.removeNotify.emit();
  }

  private propagateChange = (_: any) => { };

  public writeValue(obj) {
    // console.log('======= ************ writeValue', obj)
    this.selectedArgomento = obj;
  }

  public registerOnChange(fn: any) {
    this.propagateChange = fn;
  }

  public registerOnTouched() { }
}



// WEBPACK FOOTER //
// ./src/app/components/book/argomento-selector/argomento-selector.component.ts